import { render, staticRenderFns } from "./ClientCompanyCard.vue?vue&type=template&id=6c312ded"
import script from "./ClientCompanyCard.vue?vue&type=script&lang=js"
export * from "./ClientCompanyCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports